/**
 * Created by weid on 2017/9/5.
 */
import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';
import userInfo from './userInfo';
import shopData from './shopList';

export const createReducer = (asyncReducers = {}) => {
    return combineReducers({
        form,
        userInfo,
        ...shopData,
        ...asyncReducers
    });
};



// WEBPACK FOOTER //
// ./src/rootRedux/reducers/createReducer.js